import isMobile from '../core/isMobile';
import Timer from '../core/Timer';
function Resizer({div, divInner, minWidth, minHeight, maxWidth, maxHeight, 
		bounds, callbackResized, callbackInstantaneous, callbackStarted, 
		toInclude, fixedAspectRatio}) {
    var bounds = {maxYPx:2000,
	minYPx:0,
	maxXPercentage:100,
	minXPercentage:0};
	if(toInclude===undefined||toInclude===null)toInclude = {top:true, left:true, bottom:true, right:true,
		leftTop:true, leftBottom:true, rightTop:true, rightBottom:true};
		
	var divLeft, divTop , divRight, divBottom, divLeftTop, divLeftBottom, divRightTop, divRightBottom;
	
	this.setFixedAspectRatio = function(value){
		fixedAspectRatio= value;
	};
	if(toInclude.leftTop){
		divLeftTop = document.createElement('div');
		setCornerGeneric(divLeftTop);
		divLeftTop.style.top = '0px';
		divLeftTop.style.left = '0px';
		divLeftTop.style.cursor = 'nw-resize';
	}
	if(toInclude.leftBottom){
		divLeftBottom = document.createElement('div');
		setCornerGeneric(divLeftBottom);
		divLeftBottom.style.bottom = '0px';
		divLeftBottom.style.left = '0px';
		divLeftBottom.style.cursor = 'sw-resize';
	}
	
	if(toInclude.rightTop){
		divRightTop = document.createElement('div');
		setCornerGeneric(divRightTop);
		divRightTop.style.top = '0px';
		divRightTop.style.right = '0px';
		divRightTop.style.cursor = 'sw-resize';
	}
	
	if(toInclude.rightBottom){
		divRightBottom = document.createElement('div');
		setCornerGeneric(divRightBottom);
		divRightBottom.style.bottom = '0px';
		divRightBottom.style.right = '0px';
		divRightBottom.style.cursor = 'nw-resize';
	}
	if(toInclude.left){
		divLeft = document.createElement('div');
		divLeft.style = `position:absolute;z-index:100;width:${Resizer.WIDTH}px;height:100%;left:0px;top:0px;cursor:e-resize;`;
	}
	if(toInclude.right){
		divRight = document.createElement('div');
		divRight.style = `position:absolute;z-index:100;width:${Resizer.WIDTH}px;height:100%;right:0px;top:0px;cursor:e-resize;`;
    }
	if(toInclude.top){
		divTop = document.createElement('div');
		divTop.style = `position:absolute;z-index:100;width:100%;height:${Resizer.WIDTH}px;top:0px;left:0px;cursor:n-resize;`;
    }
	if(toInclude.bottom){
		divBottom = document.createElement('div');
		divBottom.style = `position:absolute;z-index:100;width:100%;height:${Resizer.WIDTH}px;bottom:0px;left:0px;cursor:n-resize;`;
    }
	function setCornerGeneric(div)
    {
        div.style.position = 'absolute';
        div.style.width = '10px';
        div.style.height = '10px';
        div.style.zIndex = '102';
    }
    if(minWidth<maxWidth)
    {
		if(divLeft)
			div.appendChild(divLeft);
		if(divRight)
			div.appendChild(divRight);
    if(minHeight<maxHeight)
    {
		if(toInclude.leftTop)
			div.appendChild(divLeftTop);
		if(toInclude.leftBottom)
			div.appendChild(divLeftBottom);
		if(toInclude.rightTop)
			div.appendChild(divRightTop);
		if(toInclude.rightBottom)
			div.appendChild(divRightBottom);
    }
    }
    if(minHeight<maxHeight)
    {
		if(toInclude.top)
			div.appendChild(divTop);
		if(toInclude.bottom)
			div.appendChild(divBottom);
    }
    if(minWidth<maxWidth&&minHeight<maxHeight)
    {
		if(toInclude.leftTop)
			div.appendChild(divLeftTop);
		if(toInclude.leftBottom)
			div.appendChild(divLeftBottom);
		if(toInclude.rigtTop)
			div.appendChild(divRightTop);
		if(toInclude.rightButton)
			div.appendChild(divRightBottom);
    }
    var state = 'up';
    var startOffset = [];
    var timer;
    var moveEvent;
    var upEvent;
    this.setDimensions = function (array) {
        div.style.width = String(array[0]) + 'px';
        div.style.height = String(array[1]) + 'px';
    };
    this.getDimensions = function () {
        var array = [];
        array[0] = div.offsetWidth;
        array[1] = div.offsetHeight;
        return array;
    };
    function onMouseDown(e)
    {
		e.stopPropagation&&e.stopPropagation();
		e.preventDefault&&e.preventDefault();
        if (!isMobile)
        {
            moveEvent = function (e) {
                if (!e)
                    e = window.event;
				e.stopPropagation&&e.stopPropagation();
				e.preventDefault&&e.preventDefault();
                doResize(e);
				
            };
            document.documentElement.addEventListener("mousemove", moveEvent);
            upEvent = function (e)
            {
                if (!e)
                    var e = window.event;

                state = 'up';
                document.documentElement.removeEventListener("mousemove", moveEvent);
                document.documentElement.removeEventListener("mouseup", upEvent);
            };
            document.documentElement.addEventListener("mouseup", upEvent);
        }
        else
        {
            moveEvent = function (e) {
                if (!e)
                    var e = window.event;
                doResize(e);
            };
            document.documentElement.addEventListener("touchmove", moveEvent);
            upEvent = function (e)
            {
                if (!e)
                    var e = window.event;

                state = 'up';
                document.documentElement.removeEventListener("touchmove", moveEvent);
                document.documentElement.removeEventListener("touchend", upEvent);
            };
            document.documentElement.addEventListener("touchend", upEvent);
        }
        timer = new Timer({callback:function () {
            if (callbackResized != undefined) {
            try
            {
                callbackResized();
            }
            catch(ex)
            {
                console.log(ex);
            }
            }
        }, delay:1000, nTicks:1});
		callbackStarted&&callbackStarted(e);
    }
    if (!isMobile)
    {
		if(divLeft)
			divLeft.onmousedown = function (e) {
				state = 'down-left';
				startOffset[0] = div.offsetWidth + e.pageX - (2 * Resizer.padding);
				startOffset[1] = div.offsetLeft - e.pageX;
				onMouseDown(e);
			};
		if(divRight)
			divRight.onmousedown = function (e) {
				state = 'down-right';
				startOffset[0] = div.offsetWidth - (e.pageX + (2 * Resizer.padding));
				onMouseDown(e);
			};
		if(divTop)
			divTop.onmousedown = function (e) {
				state = 'down-top';
				startOffset[0] = div.offsetHeight + e.pageY - (2 * Resizer.padding);
				startOffset[1] = div.offsetTop - e.pageY;
				onMouseDown(e);
			};
		if(divBottom)
			divBottom.onmousedown = function (e) {
				state = 'down-bottom';
				startOffset[0] = div.offsetHeight - (e.pageY + (2 * Resizer.padding));
				onMouseDown(e);
			};
		if(divLeftTop)
			divLeftTop.onmousedown = function (e) {
				state = 'down-left-top';
				startOffset[0] = div.offsetWidth + e.pageX - (2 * Resizer.padding);
				startOffset[1] = div.offsetLeft - (e.pageX);
				startOffset[2] = div.offsetHeight + e.pageY - (2 * Resizer.padding);
				startOffset[3] = div.offsetTop - e.pageY;
				onMouseDown(e);
			};
		if(divLeftBottom)
			divLeftBottom.onmousedown = function (e) {
				state = 'down-left-bottom';
				startOffset[0] = div.offsetWidth + e.pageX - (2 * Resizer.padding);
				startOffset[1] = div.offsetLeft - (e.pageX);
				startOffset[2] = div.offsetHeight - (e.pageY + (2 * Resizer.padding));
				onMouseDown(e);
			};
		if(divRightTop)
			divRightTop.onmousedown = function (e) {
				state = 'down-right-top';
				startOffset[0] = div.offsetWidth - (e.pageX + (2 * Resizer.padding));
				startOffset[1] = div.offsetHeight + (e.pageY - (2 * Resizer.padding));
				startOffset[2] = div.offsetTop - e.pageY;
				onMouseDown(e);
			};
		if(divRightBottom)
			divRightBottom.onmousedown = function (e) {
				state = 'down-right-bottom';
				startOffset[0] = div.offsetWidth - (e.pageX + (2 * Resizer.padding));
				startOffset[1] = div.offsetHeight - (e.pageY + (2 * Resizer.padding));
				onMouseDown(e);
			};
    }
    else
    {
		if(divLeft)
			divLeft.touchstart = function (e) {
				state = 'down-left';
				startOffset[0] = div.offsetWidth + e.touches[0].pageX - (2 * Resizer.padding);
				startOffset[1] = div.offsetLeft - e.touches[0].pageX;
				onMouseDown(e);
			};
		if(divRight)
			divRight.touchstart = function (e) {
				state = 'down-right';
				startOffset[0] = div.offsetWidth - (e.touches[0].pageX + (2 * Resizer.padding));
				onMouseDown(e);
			};
		if(divTop)
			divTop.touchstart = function (e) {
				state = 'down-top';
				startOffset[0] = div.offsetHeight + e.touches[0].pageY - (2 * Resizer.padding);
				startOffset[1] = div.offsetTop - e.touches[0].pageY;
				onMouseDown(e);
			};
		if(divBottom)
			divBottom.touchstart = function (e) {
				state = 'down-bottom';
				startOffset[0] = div.offsetHeight - (e.touches[0].pageY + (2 * Resizer.padding));
				onMouseDown(e);
			};
		if(divLeftTop)
			divLeftTop.touchstart = function (e) {
				state = 'down-left-top';
				startOffset[0] = div.offsetWidth + e.touches[0].pageX - (2 * Resizer.padding);
				startOffset[1] = div.offsetLeft - (e.touches[0].pageX);
				startOffset[2] = div.offsetHeight + e.touches[0].pageY - (2 * Resizer.padding);
				startOffset[3] = div.offsetTop - e.touches[0].pageY;
				onMouseDown(e);
			};
		if(divLeftBottom)
			divLeftBottom.touchstart = function (e) {
				state = 'down-left-bottom';
				startOffset[0] = div.offsetWidth + e.touches[0].pageX - (2 * Resizer.padding);
				startOffset[1] = div.offsetLeft - (e.touches[0].pageX);
				startOffset[2] = div.offsetHeight - (e.touches[0].pageY + (2 * Resizer.padding));
				onMouseDown(e);
			};
		if(divRightTop)
			divRightTop.touchstart = function (e) {
				state = 'down-right-top';
				startOffset[0] = div.offsetWidth - (e.touches[0].pageX + (2 * Resizer.padding));
				startOffset[1] = div.offsetHeight + (e.touches[0].pageY - (2 * Resizer.padding));
				startOffset[2] = div.offsetTop - e.touches[0].pageY;
				onMouseDown(e);
			};
		if(divRightBottom)
			divRightBottom.touchstart = function (e) {
				state = 'down-right-bottom';
				startOffset[0] = div.offsetWidth - (e.touches[0].pageX + (2 * Resizer.padding));
				startOffset[1] = div.offsetHeight - (e.touches[0].pageY + (2 * Resizer.padding));
				onMouseDown(e);
			};
    }
    function resizeLeft(x, y, a, b) {
        var width = a - x;
        var left = b + x;
        var leftPercent = 100 * (left / document.documentElement.offsetWidth);
        if (leftPercent < bounds.minXPercentage || width < minWidth || width > maxWidth)
        {
            return;
        }
        div.style.width = String(width) + 'px';
        div.style.left = String(left) + 'px';
    }
    function resizeRight(x, y, a) {
        var width = a + x;
        if (width < minWidth || width > maxWidth || 100 * ((width + div.offsetLeft) / document.documentElement.offsetWidth) > bounds.maxXPercentage) {
            return;
        }
        div.style.width = String(width) + 'px';
    }
    function resizeTop(x, y, a, b) {
        var height = a - y;
        var top = b + y;
        if (top < bounds.minYPx || height < minHeight || height > maxHeight) {
            return;
        }
        div.style.height = String(height) + 'px';
        div.style.top = String(top) + 'px';
    }
    function resizeBottom(x, y, a) {
        var height = a + y;
        if (height < minHeight || height > maxHeight || div.offsetTop + height > bounds.maxYPx) {
            return;
        }
        div.style.height = String(height) + 'px';
    }
    function doResize(e) {
        var x = e.pageX;
        var y = e.pageY;
		
        switch (state) {
            case "up":
                return;
            case "down-left":
                resizeLeft(x, y, startOffset[0], startOffset[1]);
                break;
            case "down-right":
                resizeRight(x, y, startOffset[0]);
                break;
            case "down-top":
                resizeTop(x, y, startOffset[0], startOffset[1]);
                break;
            case "down-bottom":
                resizeBottom(x, y, startOffset[0]);
                break;
            case "down-left-top":
                resizeLeft(x, y, startOffset[0], startOffset[1]);
                resizeTop(x, y, startOffset[2], startOffset[3]);
                break;
            case "down-left-bottom":
                resizeLeft(x, y, startOffset[0], startOffset[1]);
                resizeBottom(x, y, startOffset[2]);
                break;
            case "down-right-top":
                resizeRight(x, y, startOffset[0]);
                resizeTop(x, y, startOffset[1], startOffset[2]);
                break;
            case "down-right-bottom":
                resizeRight(x, y, startOffset[0]);
                resizeBottom(x, y, startOffset[1]);
                break;
        }
        timer.reset();
        if (callbackInstantaneous)
        {
            try
            {
                callbackInstantaneous();
            }
            catch(ex)
            {
                console.log(ex);
            }
        }
    }
    this.setBounds = function (boundsIn)//work in progress.
    {
        var previousBounds = bounds;
        bounds = boundsIn;
        if (previousBounds.minYpx < bounds.minYPx)
        {

        }
        if (previousBounds.maxYPx > bounds.maxYPx)
        {

        }
        if (previousBounds.minXPercent < bounds.minXPercentage)
        {

        }
        if (previousBounds.maxXPercent > bounds.maxXPercent)
        {

        }
    };
}
Resizer.padding = 3;
Resizer.WIDTH=6;
export default Resizer;

